export const OLD_REVIEW_FORMAT_LAST_YEAR = 2019;
export const TEXT_REVIEW_FORMAT_LAST_YEAR = 2016;

export const RATINGS_MAP = {
  DRIVING: {
    title: 'Driving',
    value: 'driving',
    children: [
      { title: 'Acceleration', value: 'acceleration' },
      { title: 'Braking', value: 'brakes' },
      { title: 'Steering', value: 'steering' },
      { title: 'Handling', value: 'handling' },
      { title: 'Drivability', value: 'drivability' },
      { title: 'Off-road', value: 'offRoad' },
    ],
  },
  COMFORT: {
    title: 'Comfort',
    value: 'comfort',
    children: [
      { title: 'Seat comfort', value: 'seatComfort' },
      { title: 'Ride comfort', value: 'rideComfort' },
      { title: 'Noise & vibration', value: 'noiseVibration' },
      { title: 'Climate control', value: 'climateControl' },
    ],
  },
  INTERIOR: {
    title: 'Interior',
    value: 'interior',
    children: [
      { title: 'Ease of use', value: 'easeUse' },
      { title: 'Getting in/getting out', value: 'gettingInOut' },
      { title: 'Driving position', value: 'drivingPosition' },
      { title: 'Roominess', value: 'roominess' },
      { title: 'Visibility', value: 'visibility' },
      { title: 'Quality', value: 'quality' },
      { title: 'Convertible top', value: 'convertibletop' },
    ],
  },
  UTILITY: {
    title: 'Utility',
    value: 'utility',
    children: [
      { title: 'Small-item storage', value: 'smallItemStorage' },
      { title: 'Cargo space', value: 'cargoSpace' },
      { title: 'Child safety seat accommodation', value: 'childSafetySeat' },
      { title: 'Towing', value: 'towing' },
      { title: 'Hauling', value: 'hauling' },
    ],
  },
  TECHNOLOGY: {
    title: 'Technology',
    value: 'technology',
    children: [
      { title: 'Audio & navigation', value: 'audioNav' },
      { title: 'Smartphone integration', value: 'smartphone' },
      { title: 'Driver aids', value: 'driverAids' },
      { title: 'Voice control', value: 'voiceControl' },
      { title: 'Mobile web', value: 'mobileWeb' },
    ],
  },
};
